import React from 'react'
import PrimaryButton from '../common/PrimaryButton'
import ImageWrapper from '../common/ImageWrapper'
import Flickity from 'react-flickity-component'
import { graphql, useStaticQuery } from 'gatsby'
import AniLink from "gatsby-plugin-transition-link/AniLink"

const PersonalTeacher = () => {

    const data = useStaticQuery(query);

    const { allStrapiHomePersonalTeacher: { nodes: HomePersonalTeacher } } = data;

    const { home_personalTeacher_heading, home_personalTeacher_subheading, home_personalTeacher_carousel, home_personalTeacher_button } = HomePersonalTeacher[0];

    const flickityOptions = {
		cellAlign: "left",
		contain: true,
		pageDots: true,
        prevNextButtons: false,
		freeScroll: true,
		wrapAround: true,
		adaptiveHeight: true,
		draggable: true,
    };

    return (
        <>
            <section className="personal_teacher_main">
                <div className="personal_teacher_left">
                    <h2 dangerouslySetInnerHTML={{ __html: home_personalTeacher_heading }} />
                    <p dangerouslySetInnerHTML={{ __html: home_personalTeacher_subheading }} /> 
                    <div className="personal_teacher_button_wrapper_desktop">
                        <AniLink fade to={home_personalTeacher_button.button_redirection}>
                            <PrimaryButton ButtonText={"View All"} MaxWidth={13.9375} />
                        </AniLink>
                    </div>
                </div>
                <div className="personal_teacher_right">
                    <Flickity 						
                        className="personal_teacher_main_carousel"
						elementType={"div"}
						options={flickityOptions}
						disableImagesLoaded={false}
						reloadOnUpdate
						static
                    >
                        {home_personalTeacher_carousel.map((carouselItem) => (
                            <div className="personal_teacher_carousel_cell" key={carouselItem.id}>
                                <div className="personal_teacher_carousel_item">
                                    <ImageWrapper ImgUrl={carouselItem.carousel_image.url} MaxWidth={310} />
                                    <p className="personal_teacher_carousel_item_name">{carouselItem.carousel_heading}, {carouselItem.carousel_subheading}</p>
                                    <p className="personal_teacher_carousel_item_description">{carouselItem.carousel_description}</p>
                                </div>
                            </div>
                        ))}
                    </Flickity>
                </div>
                <div className="personal_teacher_button_wrapper_mobile">
                    <AniLink fade to={home_personalTeacher_button.button_redirection}>
                        <PrimaryButton ButtonText={"View All"} MaxWidth={13.9375} />
                    </AniLink>
                </div>
            </section>
        </>
    )
}

export const query = graphql`
{
    allStrapiHomePersonalTeacher {
    nodes {
      home_personalTeacher_heading
      home_personalTeacher_subheading
      home_personalTeacher_button {
        button_text
        button_redirection
      }
      home_personalTeacher_carousel {
        id
        carousel_heading
        carousel_subheading
        carousel_description
        carousel_image {
          url
        }
      }
    }
  }
}
`

export default PersonalTeacher